function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuyerAcc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 9106",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 834",
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    style: {
      opacity: 0.063,
      fill: "#492cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15a.465.465 0 0 1-.213-.052.211.211 0 0 1-.041-.027l-.018-.014-.028-.015a.146.146 0 0 1-.041-.031l-8.55-9.17a.4.4 0 0 1-.034-.5l3.6-5h.006a.417.417 0 0 1 .145-.132.171.171 0 0 1 .031-.012L3.88.039l.03-.012a.236.236 0 0 1 .066-.021h.043a.046.046 0 0 0 .015 0A.049.049 0 0 1 4.05 0h9.9a.049.049 0 0 1 .015 0H14.023a.25.25 0 0 1 .066.021l.03.012.023.008a.194.194 0 0 1 .031.012.418.418 0 0 1 .147.123l3.6 5a.391.391 0 0 1-.032.5l-8.55 9.17a.169.169 0 0 1-.042.029.261.261 0 0 0-.027.017l-.012.01a.227.227 0 0 1-.047.031A.465.465 0 0 1 9 15zM5.62 5.836 9 13.488l3.379-7.653zm7.732 0-2.893 6.551 6.107-6.551h-3.214zm-11.919 0 6.108 6.551-2.894-6.551zm12.774-4.31L13.581 5h3.128l-2.5-3.477zM9 1.111 5.85 5h6.3zm-5.208.414L1.29 5h3.128zM9.9.833l2.879 3.555.64-3.555H9.9zM4.58.834l.639 3.555L8.1.834z",
    transform: "translate(17 18)",
    style: {
      fill: "#492cbd"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerAcc);
export default __webpack_public_path__ + "static/media/buyer-acc.2b7a79aa.svg";
export { ForwardRef as ReactComponent };